import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import { useCart } from "../Cart/CartContext";
import CartDrawer from "../Cart/CartDrawer.jsx"
import MoreLikeThis from "./MoreLikeThis.jsx"
import Header from "../Layout/Header.jsx";
import Footer from "../Layout/Footer.jsx";

export default function ProductDetail() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [mainPreview, setMainPreview] = useState(null);
  const { cart, addToCart } = useCart();

  const normalizePath = (path) => {
    if (!path) return "";

    // Converts ./cardImages/image.jpg to /cardImages/image.jpg
    if (path.startsWith("./")) {
      return "/" + path.slice(2);
    }

    // Keeps proper root paths as-is
    if (path.startsWith("/")) {
      return path;
    }

    // Converts cardImages/image.jpg to /cardImages/image.jpg
    return "/" + path;
  };

  useEffect(() => {
    const fetchProduct = async () => {
      const ref = doc(db, "inventory", id);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const data = { id, ...snap.data() };
        setProduct(data);

        const defaultImage =
          normalizePath(data.heroImage) ||
          normalizePath(data.imageUrl) ||
          `/cardImages/${id}.jpg`;

        setMainPreview({
          type: "image",
          src: defaultImage,
        });
      }
    };

    fetchProduct();
  }, [id]);

  if (!product) return <p>Loading...</p>;
  const cartItem = cart.find((item) => item.id === product.id);
  const quantityInCart = cartItem ? cartItem.quantity : 0;

  const thumbnails = [];

  const addThumbnail = (type, src) => {
    const cleanSrc = normalizePath(src);
    if (!cleanSrc) return;

    const alreadyExists = thumbnails.some((thumb) => thumb.src === cleanSrc);
    if (!alreadyExists) {
      thumbnails.push({ type, src: cleanSrc });
    }
  };

  addThumbnail("image", product.heroImage);
  addThumbnail("image", product.imageUrl || `/cardImages/${product.id}.jpg`);
  addThumbnail("video", product.videoDemo);
  addThumbnail("image", product.detailImage1);
  addThumbnail("image", product.detailImage2);

  return (
    <>
      <Header />

      <div className="product-detail-container">
        <div>
          {mainPreview?.type === "image" && (
            <img
              src={mainPreview.src}
              alt={product.UITitle}
              className="main-preview"
            />
          )}

          {mainPreview?.type === "video" && (
            <video className="main-preview" controls>
              <source src={mainPreview.src} type="video/webm" />
              <source src={mainPreview.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>

        <div>
          <h2>{product.UITitle}</h2>

          <p className="product-description">{product.description}</p>

          <div className="detail-cart-row">
            <p className="price">${product.price.toFixed(2)}</p>

            <button
              className="detail-button"
              onClick={() => addToCart(product)}
            >
              Add to Cart
            </button>

            <span className="quantity-added">
              Quantity added: {quantityInCart}
            </span>
          </div>

          <hr />

          <div className="thumbnail-row">
            {thumbnails.map((thumb, index) => (
              <div
                key={`${thumb.type}-${thumb.src}-${index}`}
                className={`thumbnail ${
                  mainPreview?.src === thumb.src ? "selected" : ""
                }`}
                onClick={() => setMainPreview(thumb)}
              >
                {thumb.type === "video" ? (
                  <video muted>
                    <source src={thumb.src} type="video/webm" />
                    <source src={thumb.src} type="video/mp4" />
                  </video>
                ) : (
                  <img src={thumb.src} alt={`Thumbnail ${index + 1}`} />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <MoreLikeThis currentProduct={product} />
      <CartDrawer />
      <Footer />
    </>
  );
}